// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import white from '../images/white.png';
// import instagram from '../images/instagram.png';
// import facebook from '../images/facebook.png';
// import linkedin from '../images/linkedin.png';
// import './Sidebar.css';

// const Sidebar = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const role = localStorage.getItem('role'); // Get user role once

//   const handleDropdownClick = (e) => {
//     e.currentTarget.classList.toggle('active');
//     const dropdownContent = e.currentTarget.nextElementSibling;
//     if (dropdownContent) {
//       dropdownContent.style.display = dropdownContent.style.display === 'block' ? 'none' : 'block';
//     }
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('userId');
//     localStorage.removeItem('role');
//   };

//   return (
//     <div>
//       {/* Sidebar Toggle Button */}
//       <button className="sidebar-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
//         ☰
//       </button>

//       <div className={`scrollbar ${isSidebarOpen ? 'open' : 'closed'}`}>
//         <aside className="sidebar">
//           <div className="sidebar-content">
//             <div className="logo-container">
//               <img src={white} alt="whitelogo" className="logo" />
//             </div>
//             <ul className="menu-list">
//               <li><Link to="/home">Home</Link></li>
//               {role !== 'member' && (
//                 <li>
//                   <button className="dropdown-btn" onClick={handleDropdownClick}>
//                     Manage User <i className="fa fa-chevron-down"></i>
//                   </button>
//                   <div className="dropdown-container">
//                     <Link to="/adduser">Add User</Link>
//                     <Link to="/createadmin">View Users</Link>
//                   </div>
//                 </li>
//               )}
//               <li>
//                 <button className="dropdown-btn" onClick={handleDropdownClick}>
//                   One-To-One <i className="fa fa-chevron-down"></i>
//                 </button>
//                 <div className="dropdown-container">
//                   <Link to="/OneToOneAdd">Add One-To-One</Link>
//                   <Link to="/OneToOneReview">View One-To-One</Link>
//                 </div>
//               </li>
//               <li>
//                 <button className="dropdown-btn" onClick={handleDropdownClick}>
//                   Referral <i className="fa fa-chevron-down"></i>
//                 </button>
//                 <div className="dropdown-container">
//                   <Link to="/AddReferral">Add Referral</Link>
//                   <Link to="/ReferralGiven">View Referral</Link>
//                 </div>
//               </li>
//               <li>
//                 <button className="dropdown-btn" onClick={handleDropdownClick}>
//                   Fees <i className="fa fa-chevron-down"></i>
//                 </button>
//                 <div className="dropdown-container">
//                   {role !== 'member' && <Link to="/FeesAdd">Add Fees</Link>}
//                   <Link to="/FeesReview">View Fees</Link>
//                 </div>
//               </li>
//               <li>
//                 <button className="dropdown-btn" onClick={handleDropdownClick}>
//                   Attendance <i className="fa fa-chevron-down"></i>
//                 </button>
//                 <div className="dropdown-container">
//                   {role !== 'member' ? (
//                     <>
//                       <Link to="/AddMeetings">Add Attendance Date</Link>
//                       <Link to="/ViewMeetings">View/Edit Attendance</Link>
//                     </>
//                   ) : (
//                     <Link to="/ViewMeetings">View Attendance</Link>
//                   )}
//                 </div>
//               </li>
//               <li>
//                 <button className="dropdown-btn" onClick={handleDropdownClick}>
//                   Account Settings <i className="fa fa-chevron-down"></i>
//                 </button>
//                 <div className="dropdown-container">
//                   <Link to="/editprofile">Edit Profile</Link>
//                   <Link to="/changepass">Change Password</Link>
//                 </div>
//               </li>
//               <li><Link to="/ViewProfile">Chapter Members</Link></li>
//               <li><Link to="/" onClick={handleLogout}>Logout</Link></li>
//             </ul>
//             <div className="social-media">
//               <a href="https://www.facebook.com"><img src={facebook} alt="Facebook" /></a>
//               <a href="https://www.instagram.com/hlabcofficial"><img src={instagram} alt="Instagram" /></a>
//               <a href="https://www.linkedin.com"><img src={linkedin} alt="LinkedIn" /></a>
//             </div>
//           </div>
//         </aside>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import white from '../images/white.png';
import instagram from '../images/instagram.png';
import facebook from '../images/facebook.png';
import linkedin from '../images/linkedin.png';
import arrow from '../images/arrow.png';
import './Sidebar.css';

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const role = localStorage.getItem('role');

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsSidebarOpen(window.innerWidth > 768); // Open sidebar by default on desktop
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDropdownClick = (e) => {
    e.currentTarget.classList.toggle('active');
    const dropdownContent = e.currentTarget.nextElementSibling;
    if (dropdownContent) {
      dropdownContent.style.display = dropdownContent.style.display === 'block' ? 'none' : 'block';
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('role');
  };

  return (
    <div>
      {isSidebarOpen && isMobile && <div className="overlay" onClick={() => setIsSidebarOpen(false)}></div>}

      <div className={`scrollbar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <aside className="sidebar">
          <div className="sidebar-content">
            {isMobile && isSidebarOpen && (
              <img src={arrow} alt="Close" className="close-btn" onClick={() => setIsSidebarOpen(false)} style={{ cursor: 'pointer' }} />
            )}

            <div className="logo-container">
              <img src={white} alt="Logo" className="logo" />
            </div>
            <ul className="menu-list">
              <li>
                <Link to="/home" onClick={() => isMobile && setIsSidebarOpen(false)}>
                  Home
                </Link>
              </li>
              {role !== 'member' && (
                <li>
                  <button className="dropdown-btn" onClick={handleDropdownClick}>
                    Manage User <i className="fa fa-chevron-down"></i>
                  </button>
                  <div className="dropdown-container">
                    <Link to="/adduser" onClick={() => isMobile && setIsSidebarOpen(false)}>
                      Add User
                    </Link>
                    <Link to="/createadmin" onClick={() => isMobile && setIsSidebarOpen(false)}>
                      View Users
                    </Link>
                  </div>
                </li>
              )}
              <li>
                <button className="dropdown-btn" onClick={handleDropdownClick}>
                  One-To-One <i className="fa fa-chevron-down"></i>
                </button>
                <div className="dropdown-container">
                  <Link to="/OneToOneAdd" onClick={() => isMobile && setIsSidebarOpen(false)}>
                    Add One-To-One
                  </Link>
                  <Link to="/OneToOneReview" onClick={() => isMobile && setIsSidebarOpen(false)}>
                    View One-To-One
                  </Link>
                </div>
              </li>
              <li>
                <button className="dropdown-btn" onClick={handleDropdownClick}>
                  Referral <i className="fa fa-chevron-down"></i>
                </button>
                <div className="dropdown-container">
                  <Link to="/AddReferral" onClick={() => isMobile && setIsSidebarOpen(false)}>
                    Add Referral
                  </Link>
                  <Link to="/ReferralGiven" onClick={() => isMobile && setIsSidebarOpen(false)}>
                    View Referral
                  </Link>
                </div>
              </li>

              <li>
                <button className="dropdown-btn" onClick={handleDropdownClick}>
                  Fees <i className="fa fa-chevron-down"></i>
                </button>
                <div className="dropdown-container">
                  {role !== 'member' && (
                    <Link to="/FeesAdd" onClick={() => isMobile && setIsSidebarOpen(false)}>
                      Add Fees
                    </Link>
                  )}
                  <Link to="/FeesReview" onClick={() => isMobile && setIsSidebarOpen(false)}>
                    View Fees
                  </Link>
                </div>
              </li>

              <li>
                <button className="dropdown-btn" onClick={handleDropdownClick}>
                  Thank You <i className="fa fa-chevron-down"></i>
                </button>
                <div className="dropdown-container">
                  {role !== 'member' && (
                    <Link to="ThankyouAdd" onClick={() => isMobile && setIsSidebarOpen(false)}>
                      Add Thank You Slip
                    </Link>
                  )}
                  <Link to="/ThankYouReview" onClick={() => isMobile && setIsSidebarOpen(false)}>
                  View Thank You Slip
                  </Link>
                </div>
              </li>

              <li>
                <button className="dropdown-btn" onClick={handleDropdownClick}>
                  Attendance <i className="fa fa-chevron-down"></i>
                </button>
                <div className="dropdown-container">
                  {role !== 'member' ? (
                    <>
                      <Link to="/AddMeetings" onClick={() => isMobile && setIsSidebarOpen(false)}>
                        Add Attendance Date
                      </Link>
                      <Link to="/ViewMeetings" onClick={() => isMobile && setIsSidebarOpen(false)}>
                        View/Edit Attendance
                      </Link>
                    </>
                  ) : (
                    <Link to="/ViewMeetings" onClick={() => isMobile && setIsSidebarOpen(false)}>
                      View Attendance
                    </Link>
                  )}
                </div>
              </li>

              <li>
                <button className="dropdown-btn" onClick={handleDropdownClick}>
                  Account Settings<i className="fa fa-chevron-down"></i>
                </button>
                <div className="dropdown-container">
                  {role !== 'member' && (
                    <Link to="/editprofile" onClick={() => isMobile && setIsSidebarOpen(false)}>
                      Edit Profile
                    </Link>
                  )}
                  <Link to="/changepass" onClick={() => isMobile && setIsSidebarOpen(false)}>
                    Change Password
                  </Link>
                </div>
              </li>

              <li>
                <Link to="/ViewProfile" onClick={() => isMobile && setIsSidebarOpen(false)}>
                  Chapter Members
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  onClick={() => {
                    handleLogout();
                    isMobile && setIsSidebarOpen(false);
                  }}
                >
                  Logout
                </Link>
              </li>
            </ul>
            <div className="social-media">
              <a href="https://www.facebook.com">
                <img src={facebook} alt="Facebook" />
              </a>
              <a href="https://www.instagram.com/hlabcofficial">
                <img src={instagram} alt="Instagram" />
              </a>
              <a href="https://www.linkedin.com">
                <img src={linkedin} alt="LinkedIn" />
              </a>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Sidebar;
